/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {ActionType, createAction} from 'typesafe-actions';
import {StartAccountRecoveryDTO} from '../../generated/iam-client';
import {ConstraintViolationDTO} from '../../model/validation';

export const resetPasswordSceneActivated =
	createAction('RESET_PASSWORD_SCENE_ACTIVATED')();

export const resetPasswordSceneDeactivated =
	createAction('RESET_PASSWORD_SCENE_DEACTIVATED')();

export const resetPasswordSceneAccountNameInputChanged =
	createAction('RESET_PASSWORD_SCENE_ACCOUNT_NAME_INPUT_CHANGED')();

export const resetPasswordSceneAccountNameSubmitted =
	createAction('RESET_PASSWORD_SCENE_ACCOUNT_NAME_SUBMITTED')<{ command: StartAccountRecoveryDTO }>();

export const resetPasswordSceneRecoveryStarted =
	createAction('RESET_PASSWORD_SCENE_ACCOUNT_RECOVERY_STARTED')();

export const resetPasswordSceneStartAccountRecoveryValidationException =
	createAction('RESET_PASSWORD_SCENE_START_ACCOUNT_RECOVERY_VALIDATION_EXCEPTION')<{
		violations: { [key: string]: ConstraintViolationDTO[] }
	}>();

export const resetPasswordSceneAccountRecoveryUnexpectedError =
	createAction('RESET_PASSWORD_SCENE_START_ACCOUNT_RECOVERY_UNEXPECTED_ERROR')();

export const resetPasswordSceneBackButtonClicked =
	createAction('RESET_PASSWORD_SCENE_BACK_BUTTON_CLICKED')();

// noinspection DuplicatedCode
export type ActionTypes =
	ActionType<typeof resetPasswordSceneActivated> |
	ActionType<typeof resetPasswordSceneDeactivated> |
	ActionType<typeof resetPasswordSceneAccountNameInputChanged> |
	ActionType<typeof resetPasswordSceneAccountNameSubmitted> |
	ActionType<typeof resetPasswordSceneRecoveryStarted> |
	ActionType<typeof resetPasswordSceneStartAccountRecoveryValidationException> |
	ActionType<typeof resetPasswordSceneAccountRecoveryUnexpectedError> |
	ActionType<typeof resetPasswordSceneBackButtonClicked>;
